import { createPortal } from 'react-dom'
import type { Color } from '../../types/game'
import { ResourceIcon } from '../shared/ResourceIcon'
import { assetUrl } from '../../utils/assets'

interface NestingModalProps {
  canMakeHoney: boolean
  canLayEgg: boolean
  playerColor: Color
  onMakeHoney: () => void
  onLayEgg: () => void
  onCancel: () => void
}

export function NestingModal({
  canMakeHoney,
  canLayEgg,
  playerColor,
  onMakeHoney,
  onLayEgg,
  onCancel,
}: NestingModalProps) {
  const appRoot = document.querySelector('.app') ?? document.body

  return createPortal(
    <div className="nesting-modal-root">
      <div className="nesting-modal-overlay" onClick={onCancel} />
      <div className="nesting-modal tableau">
        <div className="nesting-modal-options">
          <div className="nesting-modal-option-row">
            <div
              className={`nesting-modal-option${canMakeHoney ? '' : ' disabled'}`}
              onClick={canMakeHoney ? onMakeHoney : undefined}
            >
              <img src={assetUrl('images', 'cells', 'honey_cell_1.svg')} alt="" className="nesting-modal-cell-img" />
              <ResourceIcon resource="honey" className={`${playerColor} nesting-modal-token`} />
            </div>
            <div
              className={`nesting-modal-option${canLayEgg ? '' : ' disabled'}`}
              onClick={canLayEgg ? onLayEgg : undefined}
            >
              <img src={assetUrl('images', 'cells', 'egg_cell_1.svg')} alt="" className="nesting-modal-cell-img" />
              <ResourceIcon resource="egg" className={`${playerColor} nesting-modal-token`} />
            </div>
          </div>
          <div className="season-overview-close-container">
            <div className="season-overview-close" onClick={onCancel}>Cancel</div>
          </div>
        </div>
      </div>
    </div>,
    appRoot
  )
}
